import { FormReward } from 'v2/types';
import { RewardModel } from 'v2/types/RewardModel';

/** Groups flat reward list into unique rewards with a count, mirroring the legacy getRewardsWithCount. */
export const getRewardsWithCount = (rewards: RewardModel[]): FormReward[] => {
  const rewardsWithCount = new Map<string, FormReward>();

  rewards.forEach(({ type, value }) => {
    const rewardKey = `${type}_${value}`;
    const existing = rewardsWithCount.get(rewardKey);

    rewardsWithCount.set(rewardKey, {
      type,
      value,
      count: (existing?.count ?? 0) + 1,
    });
  });

  return [...rewardsWithCount.values()];
};

/** Expands rewards by their count into a flat payload of { type, value } for bulk creation. */
export const getMultipliedRewardsPayload = (rewards: FormReward[]): Pick<RewardModel, 'type' | 'value'>[] =>
  rewards.flatMap(({ type, value, count = 1 }) => Array(Number(count)).fill({ type, value }));
